import React from 'react';
import PropTypes from "prop-types";
import styles from '../NewMyPropertyTeaser.less';

const MyPropertyIcon = ({ url, alt, isHomePage }) => (
  <div className={`grid-item one-eighth palm-one-fifth grid-align-center ${isHomePage ? `${styles.iconSize}` : ``}`}>
    <img src={url} alt={alt} className={isHomePage ? `${styles.iconSize}` : ''} />
  </div>
);


MyPropertyIcon.propTypes = {
  alt: PropTypes.string,
  url: PropTypes.string,
  isHomePage: PropTypes.bool,
};

MyPropertyIcon.defaultProps = {
  isHomePage: false
};



export default MyPropertyIcon;
